import React, { useMemo } from 'react'
import { Button } from 'antd'
import { RemoveIco } from '@modules/CustomIcons'
import { Table } from '@shared/Table'
import { useFormContext } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { trustedColumns as defaultTrustedColumns } from 'pages/Orders/SalaryCardOrder/constants/trustedPerson.columns'
import { useDeleteTrustedPersonMutation, useTrustedPersonListAllQuery } from '@app/store/reducers/configs/configs.api'
import { useCustomModal } from '@shared/Modal'
import { useTranslation } from 'react-i18next'

function SelectTrustedPerson() {
  const dispatch = useDispatch()
  const { setValue } = useFormContext()
  const [deleteTrustedPerson] = useDeleteTrustedPersonMutation()
  const { closeModal, setStatus } = useCustomModal()

  const { data: trustedPersonList, isSuccess, status } =
    useTrustedPersonListAllQuery({})
   const {t} = useTranslation()
  const columns = useMemo(() => {
    const baseColumns = defaultTrustedColumns()
    return {
      ...baseColumns,
      actions: {
        width: 40,
        render: (_, record) => (
          <Button
            type="link"
            icon={<RemoveIco />}
            onClick={(e) => {
              e.stopPropagation()
              deleteTrustedPerson({ id: record.id })
            }}
          />
        ),
      },
    }
  }, [dispatch,t])

  // useEffect(() => {
  //   setStatus({ status: isSuccess ? '': status })
  // }, [status, isSuccess])

  return (
    <Table
      tableKey="trustedPersonTable"
      editColumns={columns}
      dataSource={isSuccess ? trustedPersonList : []}
      pagination={false}
      rowKey={(record) => record.id}
      onClickRow={(data) => {
        setValue('trustedPerson.id', data.id)
        setValue('trustedPerson.expiryDate', data.expiryDate, {
          shouldValidate: true,
        })
        setValue('trustedPerson.fullName', data.fullName, {
          shouldValidate: true,
        })
        setValue('trustedPerson.pin', data.pin, { shouldValidate: true })
        setValue('trustedPerson.phone', data.phone, {
          shouldValidate: true,
        })
        closeModal()
      }}
    />
  )
}

export default SelectTrustedPerson
